import { Box, useTheme, ButtonBase } from "@mui/material";
import Shbutton from "../../../../components/theme/buttons/Shbutton";

import Text from "../../../../components/theme/text/Text";
import { tokens } from "../../../../theme";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ShLabel from "../../../../components/theme/label/ShLabel";
import { useExportReturnLinesMutation, useGetAllReturnLinesQuery, useProcessReturnLinesBolMutation } from "../../../../newapi/inbound/returnsSlice"; // Changed from inboundsSlice to returnsSlice
// import ReturnsCard from "../../../../components/global/cards/returns/ReturnsCard"; // Changed from InboundsCard to ReturnsCard
import { PhonelinkOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RelationReturnCard } from "../../../../components/global/cards/inbounds/ReturnCards";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetRelationQuery } from "../../../../newapi/global/relation/relationSlice";
import { getReturnStateData } from '../../../../utils/labelColorText';
import { RETURNLINE_FILTER_KEYS } from "../../../../components/global/DataGrid/Filter";
import { general_states, return_type } from "../../../../utils/staticEnums";
import { ReactComponent as BolLogo } from '../../../../styles/svg/bol.svg';
import ShDataGridSelectedActions from "../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import MDynamicValues from "../../../../components/global/Modals/MDynamicValues";
import MReturnLinesSkipped from "../../../../components/global/Modals/MReturnLinesSkipped";
import SHQuickAction from "../../../../components/theme/Modal/SHQuickAction";
import { showToastMessageRequestError, showToastMessageUpdateRequest, showToastPromise } from "../../../../utils/toasts";
import MLoader from "../../../../components/global/Modals/MLoader";
import { DownloadOutlined } from "@mui/icons-material";
import ShCopyButton from "../../../../components/theme/ShCopy";
import { RELATION_ORDERS_DEFAULT } from "../../../../components/theme/datagrid3/groupingPresets/GroupingPresets";
import ShDataGrid3 from "../../../../components/theme/datagrid3/ShDataGrid3";
import WorkspacesIcon from '@mui/icons-material/Workspaces';
const SpReturnDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpReturnDetails/SpReturnDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <ButtonGroup version={2}>
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                onClick={() => props.exportReturnLines()}
                endIcon={<DownloadOutlined/>}
                variant="contained"
                isLoading={props.isExporting}
            >
                {t("export")}
            </Shbutton>
        </ButtonGroup>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [RETURNLINE_FILTER_KEYS.RETURN_STATE, RETURNLINE_FILTER_KEYS.ACCEPTED_COUNT, RETURNLINE_FILTER_KEYS.REJECTED_COUNT, RETURNLINE_FILTER_KEYS.PRODUCT],
};

const Returnlines = (props) => { // Changed from InboundInbounds to ReturnReturns
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended, setIsExtended] = useState(false);
    const id = useSelector((state) => state.settings.environment.selectedId);
    const [spLoading, setSpLoading] = useState();

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions:<GridActions isExporting={isExporting} exportReturnLines={exportReturnLinesCall}></GridActions>
        });

        return () => {
            
        }
    },[props.config]);

    const [relationId, setRelationId] = useState();
    const { data: relation } = useGetRelationQuery(relationId, {
        skip: !relationId
    });
            
    const [exportReturnlines, {isLoading: isExporting}] = useExportReturnLinesMutation();
    const exportReturnLinesCall = async () => {  
        if (isExporting) return;
        const exportPromise = exportReturnlines().unwrap();

        showToastPromise(
            exportPromise,
            t,
            {
                pending: t('export_processing') || 'Processing export...',
                success: t('export_success') || 'Export completed successfully',
                error: t('export_failed') || 'Export failed'
            }
        ).then((result) => {
            if (result.processing) {
                console.log('Export is being processed in background. Export ID:', result.exportId);
            }
        }).catch((error) => {
            console.error("Export failed", error);
        });
    }
        
    const [updateBolStatusOpen, setUpdateBolStatusOpen] = useState(false);
    const updateBolStatusModal = {
        open: updateBolStatusOpen,
        setOpen: setUpdateBolStatusOpen
    } 

  //  const [addLot, {isLoading: addLotLoading}] = useAddLotMutation();
    // const createNewLot = async(lotInfo) => {
    //     try {
    //         if (addLotLoading) return;
            
    //         const response = await addLot(lotInfo).unwrap();
    //         showToastMessageUpdateRequest(t, response);
    //     } catch (err) {
    //         showToastMessageRequestError(t('update_failed'),t, err);
    //     }
    // }

    const [loaderModalOpen, setLoaderModalOpen] = useState(false);
    const loaderModal = {
        open: loaderModalOpen,
        setOpen: setLoaderModalOpen,
    };

    const [skippedModal, setSkippedModal] = useState({ open: false, skipped: [] });

    const [processReturnLines, {isLoading: linesLoading}] = useProcessReturnLinesBolMutation();
    const handleUpdateBolStatus = async(values) => {
        try {
            if (linesLoading) return;
            loaderModal.setOpen(true);
            const response = await processReturnLines({returnLineIds:selectedItems, handlingResult: values.process_type}).unwrap();
            showToastMessageUpdateRequest(t, response);

            const skipped = response?.skipped ?? [];
            if (skipped.length > 0) {
                setSkippedModal({ open: true, skipped });
            }
        } catch (e) {
            showToastMessageRequestError(t('update_failed'), t, e);
        } finally {
            loaderModal.setOpen(false);
        }
    }
    
    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (selectedItems) => {
        setSelectedItems(selectedItems);
    }

    const [returnId, setReturnId] = useState();
    const returnIdRef = useRef(returnId);
    
    const getReturnDetails = (params) => {
        if (!params?.row?.return) return;
    
        const newreturnId = parseInt(params.row.return.id);
        // Only update state if the returnId has actually changed
        if (returnIdRef.current !== newreturnId) {
            
            if(!spLoading) {
                setSpLoading(true);
            }
            setReturnId(newreturnId);
            returnIdRef.current = newreturnId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const columns = [
        {field: "order", headerName: t("order"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box
                        sx={{
                            display:'flex',
                            alignItems:"center",
                            gap:1.5,
                        }}
                    >
                        {params.row.return.type === return_type.BOL &&
                            <Box
                                sx={{
                                    flexShrink:0,
                                    width:32,
                                    height:32,
                                    background:"#E5E5F5",
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: '1px solid #000099',
                                }}
                            >
                                <BolLogo width={20}/>
                            </Box>
                        }
                        {(!params.row.return?.type || params.row.return.type === return_type.DEFAULT) &&
                            <Box
                                sx={{
                                    flexShrink:0,
                                    width:32,
                                    height:32,
                                    background:colors.grey[100],
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: `1px solid ${colors.txt["primary"]}`,
                                    color:colors.txt["primary"],
                                    "& svg": {
                                        transform:'rotate(45deg)',
                                    }
                                }}
                            >
                                <BackHandOutlinedIcon fontSize="small"/>
                            </Box>
                        }
                        <Box
                            sx={{
                                width:1,
                                display:'flex',
                                flexDirection:"column",
                            }}
                        >
                            <Text>{params.row.return?.reference} ({params.row.order?.deliveryCountry?.toUpperCase()})</Text>
                            <Text fontSize={13} light italic>{params.row.order?.webshopreference}</Text>

                        </Box>
                    </Box>
                );
            }
        },
        {field: "name", headerName: t("name"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return(
                    <Text>
                        {params.row.return?.name}
                    </Text>
                )
            }
        },
        {field: "productSku", headerName: t("sku"),flex:1,filter: RETURNLINE_FILTER_KEYS.PRODUCT,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Box
                            sx={{
                                minWidth:"100%",
                                height:"100%",
                                display:"flex",
                                alignItems:"center",
                                position:"relative",
                                whiteSpace:"nowrap",
                                wordBreak:"keep-all",
                                textOverflow:"ellipsis",
                                overflow:"hidden",
                                gap:2,

                            }}
                        >
                            <Text noBreak>{params.row.product?.sku}</Text>
                            {params.row.parentProductId &&
                                <SHQuickAction
                                    disableScrollLock={true}
                                    component={
                                        <Box
                                            sx={{
                                                px:1.5,
                                                display:"flex",
                                                flexDirection:"column"
                                            }}
                                        >
                                            <Text light>{t("part_of_virtual_product")}</Text>
                                        </Box>
                                    }
                                >
                                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                        <Box
                                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                                            aria-haspopup={false}
                                            onMouseEnter={onMouseEnter}
                                            onMouseLeave={onMouseLeave}
                                            onTouchStart={onTouchStart}
                                            sx={{
                                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                                height:32,
                                                width:32,
                                                color: colors.txt['secondary'],
                                                display:'flex',
                                                alignItems:'center',
                                                justifyContent:'center',
                                                borderRadius:4,
                                            }}
                                        >
                                            <WorkspacesIcon fontSize='small'/>
                                        </Box>
                                    )}
                                </SHQuickAction>
                            }
                        </Box>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.product?.sku}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "acceptedCount", headerName: t("accepted_count"),flex:1,filter: RETURNLINE_FILTER_KEYS.ACCEPTED_COUNT,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.acceptedCount;
            }
        },     
        {field: "rejectedCount", headerName: t("rejected_count"),flex:1,filter: RETURNLINE_FILTER_KEYS.REJECTED_COUNT,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (!params.row.internalReason || params.row.internalReason.length === 0) {
                    return params.row.rejectedCount;
                }
              
                return (
                    <SHQuickAction
                        component={ params.row.internalReason?.length > 0 ?
                            <Box
                                sx={{
                                    px:1.5,
                                    display:"flex",
                                    flexDirection:"column"
                                }}
                            >
                                <Text>{params.row.internalReason}</Text>
                            </Box>
                            : 
                            null
                        }
                    >
                        {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                            <Box
                                aria-owns={anchorEl ? 'simple-popover' : undefined}
                                aria-haspopup={false}
                                onMouseEnter={params.row.latestHandoverDateTime !== null ? onMouseEnter : null}
                                onMouseLeave={params.row.latestHandoverDateTime !== null ? onMouseLeave : null}
                                onTouchStart={params.row.latestHandoverDateTime !== null ? onTouchStart : null}
                                sx={{
                                    width:1,
                                }}
                            >
                                <Text>{params.row.rejectedCount}</Text>
                            </Box>
                        )}
                    </SHQuickAction>
                );
            }
        },

        {field: "remark", headerName: t("remark"),flex:3,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let remark = params.row.remark;
                if (params.row.externalReturnReason?.length > 0) {
                    remark = remark?.length > 0 ? `${params.row.externalReturnReason}: ${remark}` : params.row.externalReturnReason;
                }

                return remark;
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            filter: RETURNLINE_FILTER_KEYS.RETURN_STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const { labelcolor, labeltext } = getReturnStateData(params.row.state, theme);
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "updatedAt", 
            headerName: t("updated_at"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = new Date(params.row.updatedAt);
              
                return (
                    <Box>
                        <Text semibold>
                            {date.toLocaleDateString(i18n.language)}
                        </Text><br/>
                        <Text light>
                            {date.toLocaleTimeString(i18n.language,{timeStyle: 'short'})}
                        </Text>
                    </Box>
                );
            },
            grouping: RELATION_ORDERS_DEFAULT.CREATED_AT,
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <RelationReturnCard onClick={() => getReturnDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}/>
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid3 
                key={theme.palette.mode}
                gridKey={"relations.returns.lines"}
                content={useGetAllReturnLinesQuery}
                gridActions={<GridActions isExporting={isExporting} exportReturnLines={exportReturnLinesCall}></GridActions>} 
                title={t('all_returns') }
                gridOptions={gridOptions} 
                sortModel={{field: columns[7].field,type:"DESC"}}
                columns={columns}
                onRowClick={getReturnDetails}
                selectable
                setSelected={onSelected}
                selectedItems={selectedItems}
                selectedActions={
                    <ShDataGridSelectedActions showButtons selectedItems={selectedItems}>
                        <ButtonBase
                            onClick={() => updateBolStatusModal.setOpen(true)}
                            sx={{
                                background:tokens('light').txt["white"],
                                height:40,
                                borderRadius:7,
                                fontSize:"14px",
                                fontFamily:"Roboto, sans-serif",
                                px:3,
                                boxShadow:"none",
                                border:"none",
                                fontWeight:500,
                                color:tokens('light').txt["primary"]
                            }}
                        >
                            {t('process_lines')}
                        </ButtonBase>
                    </ShDataGridSelectedActions>
                }
                isRowSelectable={(row) => {
                    const isBolReturn = row.webshopCredentials?.type === "bol" && row.externalId?.length > 0 && (!row.handlingResult || row.handlingResult.length === 0);
                    if(isBolReturn && [general_states.COMPLETED, general_states.DECLINED].includes(row.state)) {
                        return true;
                    }
                    return false;
                    // return row.priceIncreases?.length > 0
                }}
            > 
            </ShDataGrid3>
            <MDynamicValues
                open={updateBolStatusModal.open}
                handleClose={() => updateBolStatusModal.setOpen(false)}
                title={t("select_process_type_title")}
                labelWidth={80}
                fields={[
                    { name: "process_type", label: t("process_type"), type: "list", options: [{id: "RETURN_RECEIVED", name: t('return_received')}] }
                ]}
                onConfirm={(values) => handleUpdateBolStatus(values)}
            />
            <MLoader
                open={loaderModal.open}
                message={t("loader_lines_are_being_processed")}
            />
            <MReturnLinesSkipped
                open={skippedModal.open}
                handleClose={() => setSkippedModal({ open: false, skipped: [] })}
                skipped={skippedModal.skipped}
            />

            {spLoading && 
                <SpReturnDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    returnId={returnId}
                />
            }
            
        </Box>
    );
}

export default Returnlines; // Changed from InboundInbounds to ReturnReturns
